/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import { numericPixels, spacing } from "../../../../../global/emotion";
import type { ButtonProps } from "../Button/Button.emotion";
import { Button } from "../Button/Button.emotion";

const buttonStyle: Interpolation = {
  justifyContent: "center",
};

const sizeStyles: Record<
  NonNullable<IconButtonProps["size"]>,
  Interpolation
> = {
  s: {
    padding: spacing.xxs,
    width: spacing.xl,
  },
  m: {
    padding: spacing.s,
    width: numericPixels[40],
  },
  l: {
    padding: spacing.m,
    width: numericPixels[56],
  },
};

export type IconButtonProps = Omit<
  ButtonProps,
  "endIcon" | "isFullWidth" | "size" | "startIcon"
> & {
  icon: ButtonProps["startIcon"];
  size?: "s" | "m" | "l";
};

export const IconButton = forwardRef<any, IconButtonProps>(
  ({ icon, size = "m", ...props }, ref) => (
    <Button
      ref={ref}
      size={size}
      startIcon={icon}
      css={[buttonStyle, sizeStyles[size]]}
      {...(props as ButtonProps)}
    />
  ),
);

IconButton.displayName = "IconButton";
